import Flex, { FlexProps } from 'src/components/Layout/Flex/Flex'
import styled, { css } from 'styled-components'
import { TFunctionResultChildren } from 'src/components/Core/Typography/Font/types'
import { ModalFooter } from 'src/components/Sections/Modal/Modal.styles'

export const ListHeaderWrapper = styled('div') <{ width?: string; }>`
  width: ${props => props.width || '100%'};
  margin: 16px 0 0 0;
  border: 1px solid ${props => props.theme.colors.shades.neutral[1]};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  background-color: ${props => props.theme.colors.shades.neutral[0]};
  box-sizing: border-box;
`
export const ListHeader = styled('div')<{
  numberOfColumns: number;
  width?: string;
  insideModal?: boolean;
}>`
  min-height: 48px;
  width: ${props => props.width || 'calc(100% - 1em)'};
  display: grid;
  grid-template-columns:
    14%
    repeat(
      ${props => props.numberOfColumns - 2},
      ${props => 76 / (props.numberOfColumns - 2)}%
    )
    10%;
  align-items: center;

  padding: 8px 8px 8px 16px;
  box-sizing: border-box;
  position: relative;

  p {
    font-weight: normal;
    margin: auto 12px auto 0;
    &:has(svg) {
      align-items: center;
      justify-content: flex-end;
    }
  }

  ${props =>
    props.insideModal &&
    css`
      margin: 16px 0 0 0;
      border: 1px solid ${props.theme.colors.shades.neutral[1]};
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      padding-left: 16px;
      padding-right: 8px;
      background-color: ${props.theme.colors.shades.neutral[0]};
    `}
`

export const ListStyles = styled('ul')<{
  numberOfColumns: number;
  width?: string;
  dashboardIntegrated?: boolean;
}>`
  width: ${props => props.width || '100%'};
  margin: 0;
  padding: 0;
  border: 1px solid ${props => props.theme.colors.shades.neutral[1]};
  border-top: none;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  overflow-y: auto;
  overflow-x: hidden;
  ${props => props.dashboardIntegrated &&
    css`
      height: 492px;
    `
}
  max-height: 492px;
  box-sizing: border-box;

  li {
    list-style-type: none;
    height: 40px;
    display: grid;
    grid-template-columns:
      14%
      repeat(
        ${props => props.numberOfColumns - 2},
        ${props => 76 / (props.numberOfColumns - 2)}%
      )
      10%;
    padding-left: 16px;
    padding-right: 8px;
    border-top: 1px solid ${props => props.theme.colors.shades.neutral[1]};
  }

  li:first-of-type {
    border-top: none;
  }

  P {
    font-weight: bold;
    margin: auto 0;
  }
`

export const ListTemplatedHeader = styled('div')<{
  templateColumns: string;
  width?: string;
  insideModal?: boolean;
}>`
  min-height: 48px;
  width: ${props => props.width || 'calc(100% - 1em)'};
  display: grid;
  grid-template-columns: ${props => props.templateColumns};
  align-items: center;

  padding: 8px 8px 8px 16px;
  box-sizing: border-box;
  position: relative;

  p {
    font-weight: normal;
    margin: auto 12px auto 0;
  }

  ${props =>
    props.insideModal &&
    css`
      margin: 16px 0 0 0;
      border: 1px solid ${props.theme.colors.shades.neutral[1]};
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      padding-left: 16px;
      padding-right: 8px;
      background-color: ${props.theme.colors.shades.neutral[0]};
    `}
`

export const ListTemplatedStyles = styled('ul')<{
  templateColumns: string;
  width?: string;
  dashboardIntegrated?: boolean;
}>`
  width: ${props => props.width || '100%'};
  min-height: 42px;
  margin: 0;
  padding: 0;
  border: 1px solid ${props => props.theme.colors.shades.neutral[1]};
  border-top: none;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  overflow-x: hidden;
  ${props => props.dashboardIntegrated &&
    css`
      height: 450px;
      max-height: 450px;
    `
}

  box-sizing: border-box;

  li {
    list-style-type: none;
    height: 40px;
    display: grid;
    grid-template-columns: ${props => props.templateColumns};
    padding-left: 16px;
    padding-right: 8px;
    border-top: 1px solid ${props => props.theme.colors.shades.neutral[1]};
  }

  li:first-of-type {
    border-top: none;
  }

  P {
    font-weight: bold;
    margin: auto 12px auto 0;
  }

  svg:hover {
    cursor: pointer;
  }
`

export const ModalTitle = styled('p')<TFunctionResultChildren>`
  height: 84px;
  width: 100%;
  padding: 0 30px 0 30px;
  margin: 0 0 24px 0;
  background-color: ${props => props.theme.colors.main.backgroundDark};
  color: ${props => props.theme.colors.main.blank};
  font-family: ${props => props.theme.font?.family[1]};
  font-size: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;

  svg {
    border: 2px white solid;
    border-radius: 50%;
  }
`

export const CurrencyBreakdownList = styled('div')<{ listIndex?: number }>`
  top: ${props =>
    props.listIndex === 0 ? 88 : (props.listIndex + 1) * 40 + 48}px;
  left: 0;
  width: 100%;
  height: auto;
  padding: 0 16px 16px;
  border: 1px solid ${props => props.theme.colors.shades.neutral[1]};
  background-color: ${props => props.theme.colors.main.blank};
  box-sizing: border-box;
  z-index: 1;
`

export const FlexModal = styled(Flex)<FlexProps & { width?: string, height?: string, maximunWidth?: string; }>`
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -60%);
  width: ${props => props.width || '90%'};
  height:${props => props.height || '70%'};
  background-color: white;

  ${props => props.maximunWidth && css`
    max-width: ${props.maximunWidth};
  `}

  ${ModalTitle} + div {
    height: 100%;
  }

  ${ModalFooter} {
    box-sizing: border-box;
    width: 100%;
    margin: 32px 0 0 0;
    padding-right: 34px;
  }
`

export const EquityContentWrapper = styled(Flex)`
  height: 100%;
`

export const Underlay = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.colors.main.dark};
  opacity: 0.8;
  z-index: 1;
  overscroll-behavior: contain;
`

export const EquitySummaryDetailsModalWrapper = styled(Flex)`
  background-color: white;
  position: absolute;
  z-index: 2;
  width: 50%;
  height: auto;
  max-height: 50%;

  td {
    display: table-cell;
    width: auto;
  }
`

export const EquityDetailsModalHeader = styled(Flex)`
  width: 100%;
  height: 48px;
  padding: 24px 32px;
  background-color: ${props => props.theme.colors.main.dark};
`

export const EquityDetailsModalContentWrapper = styled(Flex)`
  width: 100%;
  padding: 32px;
  background-color: white;

  button {
    font-size: ${props => props.theme.font.size.h5};
    padding: 8px 16px;
  }
`

export const EquityDetailTableWrapper = styled(Flex)`
  & > div:first-of-type {
    background-color: ${props => props.theme.colors.shades.neutral[0]};
  }

  span {
    width: 12%;
  }
`

export const SectionHeader = styled(Flex).attrs({
  justifyContent: 'space-between',
  maxWidth: true,
})`
`

export const IconsWrapper = styled(Flex)`
  margin-top: 8px;
`

export const ViewIconWrapper = styled(Flex)`
  transform: translateY(-2px);
`
